import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Table, Button, Modal, Row, Col, Spin, Input, Form, Pagination } from 'antd';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';
import { formItemLayout } from 'constants/layout';
import { formatRating } from 'utils/formatting';

// import { DiscountTeacherModal } from 'components';

import { connect } from 'react-redux';
// import { getTeachers, activeArticle, recommendArticle, unrecommendArticle, deleteArticle } from 'redux/modules/class';
import { getTeachers, getAllTeachers, editTeacher } from 'data/teacher';
import { TableHelper, exportAsExcel } from 'helpers/Table';

import Utils from 'utils/utils';

import classes from '../styles/teacher/TeacherList.module.scss';
import moment from 'moment';
import COLUMNS from './TeacherListColumns';
import ComFeeModal from './ComFeeModal';

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;
const pageLimit = 20;
const Confirm = Modal.confirm;

class TeacherList extends Component {
  constructor(props) {
    super(props);
    this.onClickRow = this.onClickRow.bind(this);
    this.changeFocusPage = this.changeFocusPage.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onRecommendClick = this.onRecommendClick.bind(this);
    this.onUnrecommendClick = this.onUnrecommendClick.bind(this);
    this.onInputSearch = this.onInputSearch.bind(this);
    this.onSearchInputPress = this.onSearchInputPress.bind(this);
    this.onTableChange = this.onTableChange.bind(this);

    this.state = {
      collapseMobile: [],
      showModal: false,
      page: props.page,
      displaySearchValue: '',
      searchBy: props.location.query.searchBy ? props.location.query.searchBy : 'all',
      searchValue: props.location.query.q ? props.location.query.q : '',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
    };
  }

  getTeacherList = async (query) => {
    this.setState({ teacherLoading: true });
    const teachers = await getTeachers(query);

    this.setState({ teacherLoading: false, teachers: teachers.results, page: teachers.currentPage, count: teachers.count });
  };

  componentDidMount = async () => {
    this.setState({ teacherLoading: true });
    const teachers = await getTeachers(this.props.location.query);

    this.setState({ teacherLoading: false, teachers: teachers.results, page: teachers.currentPage, count: teachers.count });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  componentWillReceiveProps(props) {
    this.setState({
      searchBy: props.location.query.searchBy ? props.location.query.searchBy : 'all',
      searchValue: props.location.query.q ? props.location.query.q : '',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
      page: props.location.query.page ? parseInt(props.location.query.page, 10) : 1,
    });
  }

  componentWillUnmount() {
    if (this.backListener) {
      this.backListener();
    }
  }

  onClickRow(record, index) {
    console.log(record, index);
    // browserHistory.push(`/class/${record.slug}`);
  }

  onChangePage(page) {
    this.setState(
      {
        page: page,
      },
      () => {
        this.getTeachers(_.merge(this.getCurrentQuery(), { page }));
      },
    );
  }

  onSearch() {
    this.setState(
      {
        page: 1,
        searchValue: this.state.displaySearchValue,
      },
      () => {
        this.getTeachers(_.merge(this.getCurrentQuery(), { q: this.state.displaySearchValue, page: 1 }));
      },
    );
  }

  onInputSearch(event) {
    this.setState({
      displaySearchValue: event.target.value,
    });
  }

  onSearchInputPress(event) {
    if (event.charCode === 13) {
      this.onSearch();
    }
  }

  onRecommendClick(id) {
    editTeacher(id, { isTeacherOfTheWeek: true }).then(() => {
      this.getTeachers(this.getCurrentQuery()).then((response) => {
        console.log(response);
      });
    });
  }

  onUnrecommendClick(id) {
    editTeacher(id, { isTeacherOfTheWeek: false }).then(() => {
      this.getTeachers(this.getCurrentQuery()).then((response) => {
        console.log(response);
      });
    });
  }

  onTableChange(a, b, sorter) {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onSearch);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onSearch);
    }
  }

  getCurrentQuery() {
    return {
      page: this.state.page,
      searchBy: this.state.searchBy,
      q: this.state.searchValue,
      sortBy: this.state.sortBy,
    };
  }
  getTeachers = async (query) => {
    this.setState({ teacherLoading: true });
    const teachers = await getTeachers(query);
    this.setState({ teacherLoading: false, teachers: teachers.results, page: teachers.currentPage, count: teachers.count });
    browserHistory.push(`${this.props.location.pathname}${Utils.createQueryString(query)}`);
  };

  exportToExcel = async () => {
    await getAllTeachers(this.getCurrentQuery()).then((resultObj) => {
      const results = resultObj.results;
      const content = results.map((singleContent, key) => {
        singleContent.key = key;
        return singleContent;
      });
      const selectedStatusColumn = _.get(_.find(this.teacherSearchBy, { value: this.state.searchBy }), 'column');
      let columns = COLUMNS[selectedStatusColumn].map((colName) => {
        const col = _.find(this.columns, { dataIndex: colName });
        return col;
      });
      columns = _.compact(columns);
      exportAsExcel({
        filename: `TEACHERS-${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`,
        sheetName: 'Sheet1',
        columns,
        data: content,
      });
    });
  };

  changeFocusPage(event) {
    const searchBy = event.key;
    this.setState({
      searchBy,
      page: 1,
    });
    this.getTeachers(_.merge(this.getCurrentQuery(), { searchBy, page: 1 }));
  }

  reloadData = () => {
    this.getTeachers(this.getCurrentQuery());
  };

  openModal(teacher) {
    this.setState({
      selectedTeacher: teacher,
      isFeeModalOpen: true,
    });
  }
  closeModal() {
    this.setState({
      selectedTeacher: null,
      isFeeModalOpen: false,
    });
  }

  columns = [
    {
      ...TableHelper.defaultColumn('No.', 'teacherCode'),
      render: (value, record) => (
        <div className="no-wrap">
          <Link to={`/teacher/${record._id}`}>{value} </Link>
          {record.remark && <Icon type="pushpin" />}
        </div>
      ),

      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Teacher name', 'name'),
      render: (value, record) => {
        const { first, last } = record.name;
        const isVerified = _.get(record, 'verified');
        return (
          <div>
            <span>{`${first} ${last} `} </span>
            {isVerified && <Icon type="check-circle" className="text-primary" />}
          </div>
        );
      },
      renderExcel: (value, record) => {
        const { first, last } = record.name;
        return <div>{`${first} ${last}`}</div>;
      },
    },
    {
      ...TableHelper.dateColumn('Request date', 'user.requestedDate'),
      sorter: true,
    },
    {
      ...TableHelper.dateColumn('Request date', 'bankAccountPendingDate'),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Bank', 'bankName'),
    },
    {
      ...TableHelper.defaultColumn('A/C No.', 'bankAccount'),
    },
    {
      ...TableHelper.defaultColumn('Tax Info', 'tax'),
      render: (value, record) => {
        const taxInformation = record.taxInformation;
        const name = _.get(taxInformation, 'name.first') ? `${taxInformation.title} ${_.get(taxInformation, 'name.first')} ${_.get(taxInformation, 'name.last')}` : '';
        return (
          <div>
            <div>
              <span className="bold">เลขบัตรประชาชน:</span> {taxInformation.taxId}
            </div>
            <div>
              <span className="bold">ชื่อ:</span> {name}
            </div>
            <div>
              <span className="bold">ที่อยู่:</span> {taxInformation.address}
            </div>
            <div>
              <span className="bold">จังหวัด:</span> {taxInformation.province}
            </div>
            <div>
              <span className="bold">รหัสไปรษณีย์:</span> {taxInformation.postalCode}
            </div>
          </div>
        );
      },
      renderExcel: (value, record) => {
        const taxInformation = record.taxInformation;
        const name = _.get(taxInformation, 'name.first') ? `${taxInformation.title} ${_.get(taxInformation, 'name.first')} ${_.get(taxInformation, 'name.last')}` : '';
        return (
          <div>
            <div>
              <span className="bold">เลขบัตรประชาชน:</span> {taxInformation.taxId}
            </div>
            <div>
              <span className="bold">ชื่อ:</span> {name}
            </div>
            <div>
              <span className="bold">ที่อยู่:</span> {taxInformation.address}
            </div>
            <div>
              <span className="bold">จังหวัด:</span> {taxInformation.province}
            </div>
            <div>
              <span className="bold">รหัสไปรษณีย์:</span> {taxInformation.postalCode}
            </div>
          </div>
        );
      },
    },
    {
      ...TableHelper.dateColumn('Request date', 'taxInfoPendingDate'),
    },
    {
      ...TableHelper.integerColumn('Followers', 'followerCount'),
      sorter: true,
    },
    {
      ...TableHelper.integerColumn('Students', 'studentCount'),
      sorter: true,
    },
    {
      ...TableHelper.integerColumn('Reviews', 'reviewCount'),
      render: (value, record) => {
        const avgRating = formatRating(record.averageRating);
        return `${avgRating} (${value})`;
      },
      renderExcel: (value, record) => {
        const avgRating = formatRating(record.averageRating);
        return `${avgRating} (${value})`;
      },
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Ranking', 'level'),
      render: (value) => {
        return (
          <span>
            {value === 'ordinary' && <span>Normal</span>}
            {value === 'bronze' && <span>Bronze</span>}
            {value === 'silver' && <span>Silver</span>}
            {value === 'gold' && <span>Gold</span>}
          </span>
        );
      },
      sorter: true,
    },
    {
      ...TableHelper.priceColumn('Acc Rev.', 'totalRevenue'),
      sorter: true,
    },
    {
      ...TableHelper.integerColumn('%Com\nDisc', 'feeDiscount'),
      sorter: true,
    },
    {
      ...TableHelper.integerColumn('Disc\nRemain', 'feeDiscountRemaining'),
      sorter: true,
    },
    {
      ...TableHelper.dateColumn('Disc\nExp.', 'feeDiscountExpired'),
      sorter: true,
    },
    {
      title: '',
      dataIndex: 'command',
      render: (value, record) => {
        const _id = _.get(record, '_id');
        const isTeacherOfTheWeek = record.isTeacherOfTheWeek;
        const element = isTeacherOfTheWeek ? (
          <Icon onClick={(e) => this.onUnrecommendClick(_id)} type="star" className="text-warning pointer" />
        ) : (
          <Icon type="star-o" onClick={(e) => this.onRecommendClick(_id)} className="pointer" />
        );
        return (
          <div className={'command-column'}>
            <a onClick={() => this.openModal(record)}>Disc</a>
            {' | '}
            <Link to={`/teacher/${_.get(record, '_id')}?selectedTab=revenue`}>
              <Icon type="pay-circle" theme="outlined" />
            </Link>
            {' | '}
            {element}
          </div>
        );
      },
      width: '120',
      renderExcel: _.noop,
    },
  ];

  teacherSearchBy = [
    { label: 'All Teachers', value: 'all', column: 'all' },
    { label: 'Verified', value: 'verified', column: 'verified' },
    { label: 'Non-Verified', value: 'unverified', column: 'not_verified' },
    { label: 'Pending', value: 'pending', column: 'pending' },
    { label: 'Pending Bank A/C', value: 'pending_bank', column: 'pending_bank' },
    { label: 'Pending Tax Info', value: 'pending_tax', column: 'pending_tax' },
    { label: 'Teacher of the week', value: 'tow', column: 'tow' },
    { label: 'Banned', value: 'deleted', column: 'deleted' },
  ];

  renderPageTopMenu() {
    console.log();
    return (
      <Menu onClick={this.changeFocusPage} selectedKeys={[this.state.searchBy]} mode="horizontal" className={classes.menu}>
        {this.teacherSearchBy.map((singleClass) => (
          <Menu.Item key={singleClass.value} className={classes.dashRight}>
            <div>{singleClass.label} </div>
          </Menu.Item>
        ))}
      </Menu>
    );
  }

  renderContentTable() {
    const content = _.map(this.state.teachers, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    const selectedStatusColumn = _.get(_.find(this.teacherSearchBy, { value: this.state.searchBy }), 'column');
    let columns = COLUMNS[selectedStatusColumn].map((colName) => {
      const col = _.find(this.columns, { dataIndex: colName });
      if (col && col.hide) {
        return null;
      }
      return col;
    });
    columns = _.compact(columns);
    return (
      <div>
        <Table columns={columns} dataSource={content} bordered pagination={false} onRowClick={this.onClickRow} onChange={this.onTableChange} scroll={{ x: 1600 }} />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={this.state.count} />
      </div>
    );
  }

  render() {
    const { teacherLoading } = this.state;
    return (
      <div>
        {/* {this.state.isOpenDiscountModal && <DiscountTeacherModal reload={() => this.reloadData()} handleCancel={() => this.closeModal()} teacher={this.state.selectedTeacher} />} */}

        <div className="page-header">{this.props.BreadCrumb}</div>
        <div className="content">
          <Spin tip="Loading" size="large" spinning={!!teacherLoading}>
            {this.renderPageTopMenu()}
            <Row>
              <Col>
                <div className={classes.searchContainer}>
                  <Input prefix={<Icon type="search" />} placeholder="พิมพ์คำที่ต้องการค้นหา" onKeyPress={(e) => this.onSearchInputPress(e)} onChange={(e) => this.onInputSearch(e)} />
                </div>
              </Col>
            </Row>
            <div className="text-right">
              <a onClick={() => this.exportToExcel()}>
                <Icon type="file-excel" /> Export to excel
              </a>
            </div>
            {this.renderContentTable()}
          </Spin>
        </div>

        <ComFeeModal setIsOpen={(status) => this.setState({ isFeeModalOpen: status })} isOpen={this.state.isFeeModalOpen} teacher={this.state.selectedTeacher} reload={this.reloadData}></ComFeeModal>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    // pages: state.content.pages,
    // teacherLoading: state.teacher.teacherListWaiting,
    // teachers: state.teacher.teacherList.results,
    // page: state.teacher.teacherList.currentPage,
    // classCount: state.teacher.teacherList.count,
  }),
  { getTeachers, editTeacher, getAllTeachers },
)(Form.create()(TeacherList));
